import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('search');
const SEARCH = define('SEARCH', true);
const CLEAR = define('CLEAR');

const initialState = {
  searching: false,
  searchingMore: false,
  text: '',
  results: {},
  isShowAll: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH.PENDING:
      return {
        ...state,
        searching: !action.isShowAll && true,
        searchingMore: action.isShowAll,
        text: action.text,
      };
    case SEARCH.RESOLVED:
      return {
        ...state,
        searching: false,
        searchingMore: false,
        isShowAll: action.isShowAll,
        results: action.data,
      };
    case SEARCH.REJECTED:
      return {
        ...state,
        searching: false,
        searchingMore: false,
      };
    case CLEAR:
      return initialState;
    default: return state;
  }
};

const getPaginationKeys = (skip = 0, limit = 10) => {
  const pagination = { skip, limit };
  return {
    user: pagination,
    listing: pagination,
    booking: pagination,
    topic: pagination
  };
};

export const actions = {
  search: (text, isShowAll = false) => ({
    type: SEARCH,
    promise: (async () => {
      const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
      const apiPromise = emailRegEx.test(text) ?
        api.post('/users/email-search', {
          email: text,
          ...isShowAll ? {} : { limit: 10 }
        }).then((data) => {
          return {
            data: {
              user: data.data || [],
              booking: [],
              listing: [],
              topic: []
            }
          };
        }) :
        api.post('/elasticsearch/search', {
          text,
          keys: isShowAll ? getPaginationKeys(0, 0) : getPaginationKeys()
        });
      const resp = await apiPromise;
      return resp;
    })(),
    success: 'Search done',
    error: 'Search fail',
    text,
    isShowAll,
  }),
  clear: () => ({
    type: CLEAR,
  })
};



// WEBPACK FOOTER //
// ./src/ducks/search.js